import React from 'react';
import { Stack } from "../Stack";
import { Text } from "../Text";
import { IconButton } from "../Button";
import { IconX } from "@frameio/vapor-icons/build/esm/icons/IconX";
import styled from 'styled-components';
import { theme } from "../../theme";
import { useDialogContext } from "./DialogContext";
export function DialogHeader(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'close' : _ref$closeLabel,
      _ref$showBottomBorder = _ref.showBottomBorder,
      showBottomBorder = _ref$showBottomBorder === void 0 ? true : _ref$showBottomBorder,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton;

  var _useDialogContext = useDialogContext(),
      id = _useDialogContext.id,
      onRequestClose = _useDialogContext.onRequestClose;

  return /*#__PURE__*/React.createElement(Container, {
    $showBottomBorder: showBottomBorder
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 4
  }, /*#__PURE__*/React.createElement(Text, {
    id: id,
    variant: "primary",
    color: "primary"
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    variant: "secondary",
    color: "tertiary"
  }, subtitle)), showCloseButton && /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onRequestClose,
    variant: "link",
    icon: /*#__PURE__*/React.createElement(IconX, null),
    label: closeLabel
  }));
}
var Container = styled.div.withConfig({
  displayName: "DialogHeader__Container",
  componentId: "vapor__sc-12kwqoo-0"
})(["display:grid;grid-template-columns:1fr auto;grid-gap:", ";padding:", ";border-bottom:", ";"], theme.spaces[24], theme.spaces[16], function (p) {
  return p.$showBottomBorder && "1px solid ".concat(theme.colors.border.primary);
});